import React from 'react';
import { Spring } from 'react-spring';
import { observer, inject } from 'mobx-react';

import { redColor, blueColor } from 'js/config/style';
import Container from './Container';

import MenuButton from './MenuButton';
import DeleteIcon from './MenuButton/DeleteIcon';
import PencilIcon from './MenuButton/PencilIcon';
import CopyIcon from './MenuButton/CopyIcon';
import ShareIcon from './MenuButton/ShareIcon';

import Modal from 'js/components/core/Modal';
import Title from 'js/components/core/Modal/Title';
import Buttons from 'js/components/core/Modal/Buttons';
import Button from 'js/components/core/Modal/Button';
import ModalContent from './ModalContent';
import ModalSubtext from './ModalSubtext';

export default inject('page')(
  observer(({ page }) => {
    const {
      showManageMenu,
      copyLink,
      openModal,
      shareLink,
      can_modify,
      deleteItem,
      isDeleting,
      deleted_at,
      promptDelete,
      closeDeleteModal,
      showDeleteModal,
    } = page;

    return (
      <>
        {showManageMenu && (
          <Spring
            native
            from={{ opacity: 0, transform: 'translate3d(0,-0.5rem,0)' }}
            to={{ opacity: 1, transform: 'translate3d(0,0rem,0)' }}
            config={{ tension: 250 }}>
            {animation => (
              <Container style={animation} onClick={event => event.stopPropagation()}>
                <MenuButton disabled={!can_modify} onClick={copyLink}>
                  <CopyIcon disabled={!can_modify} />
                  Copy link
                </MenuButton>
                <MenuButton disabled={!can_modify} onClick={shareLink}>
                  <ShareIcon disabled={!can_modify} />
                  Share
                </MenuButton>
                <MenuButton disabled={!can_modify} onClick={openModal}>
                  <PencilIcon disabled={!can_modify} />
                  Edit
                </MenuButton>
                <MenuButton color={redColor} disabled={!can_modify} isBusy={isDeleting} onClick={promptDelete}>
                  <DeleteIcon disabled={!can_modify} />
                  {deleted_at ? 'Deleted' : isDeleting ? 'Deleting' : 'Delete'}
                </MenuButton>
              </Container>
            )}
          </Spring>
        )}

        <Modal showModal={showDeleteModal} onCancel={closeDeleteModal}>
          <Title>Delete this item?</Title>
          <ModalContent>
            Are you sure you wish to delete this item?
            <ModalSubtext>(this cannot be reversed)</ModalSubtext>
          </ModalContent>
          <Buttons>
            <Button color={blueColor} onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button color={redColor} defaultButton onClick={deleteItem} isBusy={isDeleting}>
              {isDeleting ? 'Deleting item...' : 'Delete'}
            </Button>
          </Buttons>
        </Modal>
      </>
    );
  }),
);
